import React, { useEffect } from 'react'
import CarouselBanner from './components/CarouselBanner'
import Notifications from './components/Notifications'
import MutualSerNews from './components/MutualSerNews'
import WelcomeTourModal from './components/WelcomeTourModal'
import { useStateValue } from 'context/store'
import { Grid, Typography, makeStyles } from '@material-ui/core'
// import MundoMutualBanner from './components/MundoMutualBanner'

const useStyles = makeStyles(theme => ({
   homePageContainer: {
      flexDirection: 'column',
      height: '100%',
      padding: theme.spacing(1, 2, 0, 2)
   },
   homePageWelcome: {
      paddingBottom: theme.spacing(1),
      paddingLeft: theme.spacing(0.5)
   },
   homePageWelcomeMessage: {
      font: 'normal normal 900 22px/29px Roboto',
      letterSpacing: '0.18px',
      color: '#43496A'
   },
   homePageWelcomeMessageUserName: {
      textTransform: 'Capitalize'
   },
   homePageSection: {
      height: '421px'
   },
   homePageSectionLeft: {
      marginBottom: '12px'
   },
   [theme.breakpoints.up('md')]: {
      homePageSections: {
         display: 'flex'
      },
      homePageSection: {
         flex: '0 1 50%'
      },
      homePageSectionRight: {
         paddingLeft: '6px'
      },
      homePageSectionLeft: {
         paddingRight: '6px',
         marginBottom: '0px'
      }
   }
}))

const HomePage = () => {
   const [{ sessionUser = {}, playWelcomeTour = {} }, dispatch] = useStateValue()
   // console.log('🚀 ~ HomePage ~ sessionUser:', sessionUser)

   const classes = useStyles()
   const userSettings = sessionUser?.settings

   const userName =
      userSettings?.documentType === 'NI'
         ? userSettings?.entity?.name?.toLowerCase()
         : userSettings?.name?.toLowerCase()

   useEffect(() => {
      if (playWelcomeTour.ask) {
         /*
            NOTA: El primer paso del tour es el leftMenu, se debe tener abierto previamente
            para que el plugin lo reconozca y haga el higlight correctamente
         */
         dispatch({ type: 'OPEN_MENU_DRAWER' })
      }
   }, [])

   return (
      <>
         <Grid className={classes.homePageContainer}>
            <Grid className={classes.homePageWelcome}>
               <Typography className={classes.homePageWelcomeMessage}>
                  Bienvenido(a)
                  <span className={classes.homePageWelcomeMessageUserName}>{` ${userName} `}</span>a ZONA SER
               </Typography>
            </Grid>
            <CarouselBanner />
            <Grid className={classes.homePageSections}>
               {/*<Grid*/}
               {/*   className={`${classes.homePageSection} ${classes.homePageSectionLeft}`}*/}
               {/*   data-wt="welcometour_mundoMutual"*/}
               {/*>*/}
               {/*   <MundoMutualBanner />*/}
               {/*</Grid>*/}
               <Grid
                  className={`${classes.homePageSection} ${classes.homePageSectionRight}`}
                  data-wt="welcometour_notifications"
               >
                  <Notifications />
               </Grid>
            </Grid>
         </Grid>
         {playWelcomeTour.ask && <WelcomeTourModal />}
      </>
   )
}

export default HomePage
